module.exports = __webpack_public_path__ + "static/img/MBTT.192abf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MBTT.jpg
// module id = 6W5r
// module chunks = 1